/**
 * The pure production-build mode guard lives in its own `import.meta`-free
 * module so the Node build pipeline (`vite.config.ts`) can import it to FAIL a
 * mock-mode production build before `dist/` is ever produced. It is re-exported
 * here so the public `config` API (`guardProductionMode`) is unchanged.
 */
export { guardProductionMode } from "./prod-mode-guard";

export const appConfig = {
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL ?? "",
  authMode: import.meta.env.VITE_AUTH_MODE ?? "mock",
  dataMode: import.meta.env.VITE_DATA_MODE ?? "mock"
} as const;

/** True when the platform auth lane is wired to the real OTP/session backend. */
export function isLiveAuthMode() {
  return appConfig.authMode === "live";
}

/** True when product reads/writes are wired to the real coaching API. */
export function isLiveDataMode() {
  return appConfig.dataMode === "live";
}

/** True when either lane is live — i.e. any live runtime posture. */
export function isLiveMode() {
  return isLiveAuthMode() || isLiveDataMode();
}

/**
 * Evidence/mock affordances — most importantly the URL `?role=`/`?scope=`
 * overrides used by the deterministic Playwright/evidence suites — are only
 * honored when `VITE_EVIDENCE_MODE=1` is set AND neither lane is live. A live
 * build can never trust the query string for role or record scope, so any
 * stray `VITE_EVIDENCE_MODE` in a production bundle is forced off here.
 */
export function isEvidenceModeEnabled() {
  return import.meta.env.VITE_EVIDENCE_MODE === "1" && !isLiveAuthMode() && !isLiveDataMode();
}
